import UserMenuGroup from '../UserMenuGroup';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

const UserMenuInjected = _ref => {
  let {
    injectedMenus
  } = _ref;
  if (!injectedMenus) return null;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: injectedMenus.filter(group => group.length).map((group, index) => /*#__PURE__*/_jsx(UserMenuGroup, {
      children: group.map(_ref2 => {
        let {
          title,
          items
        } = _ref2;
        return /*#__PURE__*/_jsx(UserMenuGroup.Item, {
          title: title,
          children: items.map(_ref3 => {
            let {
              title: itemTitle,
              href
            } = _ref3;
            return /*#__PURE__*/_jsx(UserMenuGroup.Action, {
              href: href,
              children: itemTitle
            }, href);
          })
        }, title);
      })
    }, index))
  });
};

export default UserMenuInjected;